(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function naturalParts(value) {
    return String(value || '').toLowerCase().match(/\d+|[^\d]+/g) || [];
  }

  function normalizedSize(value) {
    return String(value || '')
      .toUpperCase()
      .replace(/[–—]/g, '-')
      .replace(/[（）]/g, function (character) { return character === '（' ? '(' : ')'; })
      .replace(/^ASIA(?:N)?(?:\s*-\s*|\s+)/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function sizeSortKey(value) {
    var clean = normalizedSize(value);
    if (/\b(?:ONE|FREE)[ -]?SIZE\b/.test(clean) || /^(?:OS|O\/S)$/.test(clean)) {
      return [8, 0];
    }

    var age = clean.match(/^([0-9]+(?:\.[0-9]+)?)(?:\s*[-/]\s*([0-9]+(?:\.[0-9]+)?))?\s*(M|T|A|Y|YR|YRS|YEAR|YEARS)\b/);
    if (age) {
      var ageFactor = age[3] === 'M' ? 1 : 12;
      return [0, Number(age[1]) * ageFactor, Number(age[2] || age[1]) * ageFactor];
    }

    var scale = {
      XXXXS: 0, XXXS: 1, XXS: 2, XS: 3,
      S: 4, SMALL: 4, SM: 4.5, M: 5, MEDIUM: 5,
      L: 6, LARGE: 6, LXL: 6.5, XL: 7, '0XL': 7.5, '1XL': 8,
      XXL: 9, '2XL': 9, XXXL: 10, '3XL': 10, '4XL': 11,
      XXXXXL: 12, '5XL': 12, XXXXXXL: 13, '6XL': 13,
      '7XL': 14, '8XL': 15, '9XL': 16, '10XL': 17
    };
    var token = clean.match(/^(XXXXXXL|XXXXXL|XXXXS|XXXS|XXS|XS|SMALL|SM|S|MEDIUM|M|LARGE|LXL|L|XXXL|XXL|XL|[0-9]+XL)(?=$|\s|\(|\/|-)/);
    if (token) {
      var uk = clean.match(/\bUK\s*([0-9]+(?:\.[0-9]+)?)/);
      return [1, Object.prototype.hasOwnProperty.call(scale, token[1]) ? scale[token[1]] : 99, uk ? Number(uk[1]) : -1];
    }

    var regional = clean.match(/^(?:UK|EU|US|AU)\s*([0-9]+(?:\.[0-9]+)?)/);
    if (regional) return [2, Number(regional[1])];

    var numeric = clean.match(/^([0-9]+(?:\.[0-9]+)?)/);
    if (numeric) return [/(?:KG|LB|CM|MM|IN)\b/.test(clean) ? 4 : 3, Number(numeric[1])];
    return [9, 0];
  }

  function compareNatural(left, right) {
    var leftParts = naturalParts(left);
    var rightParts = naturalParts(right);
    var count = Math.max(leftParts.length, rightParts.length);
    for (var index = 0; index < count; index += 1) {
      if (leftParts[index] === undefined) return -1;
      if (rightParts[index] === undefined) return 1;
      var leftPart = leftParts[index];
      var rightPart = rightParts[index];
      var leftIsNumber = /^\d+$/.test(leftPart);
      var rightIsNumber = /^\d+$/.test(rightPart);
      if (leftIsNumber && rightIsNumber && Number(leftPart) !== Number(rightPart)) {
        return Number(leftPart) - Number(rightPart);
      }
      if (leftPart !== rightPart) return leftPart.localeCompare(rightPart);
    }
    return 0;
  }

  function compareSizeLabels(left, right) {
    var leftKey = sizeSortKey(left);
    var rightKey = sizeSortKey(right);
    for (var index = 0; index < Math.max(leftKey.length, rightKey.length); index += 1) {
      var leftValue = leftKey[index] === undefined ? -1 : leftKey[index];
      var rightValue = rightKey[index] === undefined ? -1 : rightKey[index];
      if (leftValue !== rightValue) return leftValue - rightValue;
    }
    return compareNatural(left, right);
  }

  function sortElementChildren(parent, elements, textValue) {
    if (!parent || elements.length < 2) return;
    elements
      .slice()
      .sort(function (left, right) {
        return compareSizeLabels(textValue(left), textValue(right));
      })
      .forEach(function (element) {
        parent.appendChild(element);
      });
  }

  function sortProductSizeOptions(scope) {
    (scope || document).querySelectorAll('.product-options__section').forEach(function (section) {
      var property = (section.getAttribute('data-property') || '').toLowerCase();
      var option = section.closest('.product-options__option');
      var optionLabel = option && option.querySelector('label');
      var labelText = optionLabel ? optionLabel.textContent.toLowerCase() : '';
      if (property.indexOf('size') === -1 && labelText.indexOf('size') === -1) return;
      if (section.getAttribute('data-jpc-size-sorted') === 'true') return;

      if (section.tagName === 'SELECT') {
        var options = Array.prototype.filter.call(section.options, function (item) {
          return !item.disabled;
        });
        sortElementChildren(section, options, function (item) { return item.textContent.trim(); });
      } else {
        var values = Array.prototype.slice.call(section.querySelectorAll(':scope > [data-js-option-value]'));
        sortElementChildren(section, values, function (item) { return item.textContent.trim(); });
      }

      section.setAttribute('data-jpc-size-sorted', 'true');
      if (optionLabel && !optionLabel.querySelector('.jpc-size-help')) {
        var help = document.createElement('span');
        help.className = 'jpc-size-help';
        help.textContent = 'Select your usual UK size';
        optionLabel.appendChild(help);
      }
    });
  }

  function sortSizeFilterValues(scope) {
    (scope || document).querySelectorAll('.jpc-native-size-filter').forEach(function (wrapper) {
      if (wrapper.getAttribute('data-jpc-size-sorted') === 'true') return;
      var labels = Array.prototype.slice.call(wrapper.querySelectorAll('label.collection-filters__checkbox'));
      sortElementChildren(wrapper, labels, function (label) {
        var input = label.querySelector('input');
        return input ? input.value : label.textContent.trim();
      });
      Array.prototype.slice.call(wrapper.children).forEach(function (child) {
        if (child.matches('[class*="col-"]') && !child.querySelector('label')) child.remove();
      });
      wrapper.setAttribute('data-jpc-size-sorted', 'true');
    });
  }

  function upgradeOrderedChoices(scope) {
    sortProductSizeOptions(scope);
    sortSizeFilterValues(scope);
  }

  function upgradeCollectionPage() {
    if (!document.body.classList.contains('template-collection')) return;

    document.querySelectorAll('.gryffeditor h1, .gryffeditor [data-jpc-h1-alternate]').forEach(function (legacyHeading) {
      var legacyRow = legacyHeading.closest('.gf_row');
      if (legacyRow) {
        legacyRow.classList.add('jpc-legacy-collection-hero');
      }
      while (legacyRow && legacyRow.parentElement && !legacyRow.parentElement.classList.contains('gryffeditor')) {
        legacyRow = legacyRow.parentElement;
      }
      if (legacyRow && legacyRow.classList.contains('gf_row')) {
        legacyRow.classList.add('jpc-legacy-collection-hero');
      }
    });

    document.querySelectorAll('.collection-page-heading').forEach(function (heading) {
      heading.classList.add('jpc-legacy-collection-heading');
    });
  }

  function routeCollectionSidebar() {
    if (!document.body.classList.contains('template-collection')) return;
    var source = document.querySelector('#CollectionSidebar');
    var destination = document.querySelector('#JpcCollectionFilterDialog [data-js-position-all="sidebar"]');
    if (source && destination && !destination.contains(source)) {
      source.classList.remove('js-position');
      source.removeAttribute('data-js-position-name');
      destination.appendChild(source);
    }
  }

  function upgradeCollectionFilters() {
    if (!document.body.classList.contains('template-collection')) return;

    var trigger = document.querySelector('#JpcCollectionFilterButton');
    var dialog = document.querySelector('#JpcCollectionFilterDialog');
    if (!trigger || !dialog) return;

    var destination = dialog.querySelector('[data-js-position-all="sidebar"]');
    function routeSidebarToDialog() { routeCollectionSidebar(); }
    routeSidebarToDialog();
    window.setTimeout(routeSidebarToDialog, 500);

    function syncDialogState() {
      var open = dialog.getAttribute('aria-hidden') === 'false' && dialog.classList.contains('visible');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    new MutationObserver(syncDialogState).observe(dialog, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class']
    });
    trigger.addEventListener('click', function () {
      routeSidebarToDialog();
      window.requestAnimationFrame(syncDialogState);
    }, true);
    syncDialogState();
  }

  function upgradeProductPage() {
    if (!document.body.classList.contains('template-product')) return;

    var productRoot = document.querySelector('.product-page__main');
    var sourceButton = productRoot && productRoot.querySelector('[data-js-product-button-add-to-cart]');
    if (!sourceButton || document.querySelector('.jpc-mobile-buybar')) return;

    var buybar = document.createElement('div');
    buybar.className = 'jpc-mobile-buybar';
    buybar.setAttribute('aria-hidden', 'true');
    buybar.innerHTML = '<div class="jpc-mobile-buybar__summary"><span class="jpc-mobile-buybar__title"></span><strong class="jpc-mobile-buybar__price"></strong></div><button type="button" class="jpc-mobile-buybar__button"></button>';
    document.body.appendChild(buybar);

    var title = document.querySelector('.product-page-info__title h1');
    var price = document.querySelector('.product-page-info__price');
    var buybarTitle = buybar.querySelector('.jpc-mobile-buybar__title');
    var buybarPrice = buybar.querySelector('.jpc-mobile-buybar__price');
    var buybarButton = buybar.querySelector('.jpc-mobile-buybar__button');

    function visibleButtonText() {
      var preferred = sourceButton.querySelector('.btn__text');
      return (preferred && preferred.textContent.trim()) || 'Add to bag';
    }

    function syncBuybar() {
      buybarTitle.textContent = title ? title.textContent.trim() : 'Your selected style';
      buybarPrice.textContent = price ? price.textContent.replace(/\s+/g, ' ').trim() : '';
      buybarButton.textContent = visibleButtonText();
      buybarButton.disabled = sourceButton.disabled;
    }

    function updateVisibility() {
      var mobile = window.matchMedia('(max-width: 767px)').matches;
      var threshold = Math.max(420, (productRoot.getBoundingClientRect().top + window.scrollY) + 520);
      var visible = mobile && window.scrollY > threshold;
      buybar.classList.toggle('is-visible', visible);
      buybar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    buybarButton.addEventListener('click', function () {
      if (sourceButton.disabled) {
        var options = productRoot.querySelector('.product-page-info__options');
        if (options) options.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      sourceButton.click();
    });

    var ticking = false;
    function requestVisibilityUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateVisibility();
        ticking = false;
      });
    }

    new MutationObserver(syncBuybar).observe(sourceButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });
    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', requestVisibilityUpdate, { passive: true });
    syncBuybar();
    updateVisibility();
  }

  function upgradeCartPage() {
    var root = document.querySelector('[data-jpc-cart-page]');
    if (!root || root.getAttribute('data-jpc-ready') === 'true') return;
    root.setAttribute('data-jpc-ready', 'true');

    root.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-jpc-quantity-minus], [data-jpc-quantity-plus]');
      if (!button) return;
      var quantity = button.parentElement && button.parentElement.querySelector('input[type="number"]');
      if (!quantity) return;
      var current = Number(quantity.value || 0);
      var next = button.hasAttribute('data-jpc-quantity-minus') ? current - 1 : current + 1;
      quantity.value = String(Math.max(0, next));
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function replaceLegacyTrackingLinks(scope) {
    (scope || document).querySelectorAll('a[href*="/apps/track123"]').forEach(function (link) {
      link.setAttribute('href', '/pages/track-order');
    });
  }

  function upgradeFaqPage() {
    var root = document.querySelector('[data-jpc-page="faq"]');
    if (!root || root.getAttribute('data-jpc-ready') === 'true') return;
    root.setAttribute('data-jpc-ready', 'true');

    var form = root.querySelector('[data-jpc-faq-search-form]');
    var input = root.querySelector('[data-jpc-faq-search]');
    var status = root.querySelector('[data-jpc-faq-status]');
    var empty = root.querySelector('[data-jpc-faq-empty]');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-jpc-faq-category]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-jpc-faq-group]'));
    var activeCategory = 'all';

    function normalize(value) {
      return String(value || '').toLowerCase().replace(/[^a-z0-9£]+/g, ' ').trim();
    }

    function filterFaq() {
      var query = normalize(input && input.value);
      var matches = 0;
      groups.forEach(function (group) {
        var categoryMatch = activeCategory === 'all' || group.getAttribute('data-jpc-faq-group') === activeCategory;
        var visibleItems = 0;
        group.querySelectorAll('[data-jpc-faq-item]').forEach(function (item) {
          var searchMatch = !query || normalize(item.textContent).indexOf(query) !== -1;
          var visible = categoryMatch && searchMatch;
          item.hidden = !visible;
          if (visible) {
            visibleItems += 1;
            matches += 1;
          } else {
            item.removeAttribute('open');
          }
        });
        group.hidden = visibleItems === 0;
      });
      if (empty) empty.hidden = matches !== 0;
      if (status) {
        status.textContent = query ? (matches + (matches === 1 ? ' answer found.' : ' answers found.')) : '';
      }
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        activeCategory = button.getAttribute('data-jpc-faq-category') || 'all';
        buttons.forEach(function (candidate) {
          var selected = candidate === button;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        filterFaq();
      });
    });

    if (input) input.addEventListener('input', filterFaq);
    if (form) form.addEventListener('submit', function (event) {
      event.preventDefault();
      filterFaq();
      var first = root.querySelector('[data-jpc-faq-item]:not([hidden])');
      if (first && input && input.value.trim()) {
        first.setAttribute('open', '');
        first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
    filterFaq();
  }

  function loadRecommendationComponent(component, url, usedFallback) {
    if (!component || !url) return;
    component.setAttribute('data-jpc-loading', 'true');
    fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendation request failed');
        return response.text();
      })
      .then(function (html) {
        var documentResponse = new DOMParser().parseFromString(html, 'text/html');
        var key = component.getAttribute('data-jpc-recommendation-key');
        var matching = documentResponse.querySelector('[data-jpc-recommendation-key="' + key + '"]');
        var result = matching && matching.querySelector('[data-jpc-recommendation-result]');
        if (result && result.children.length) {
          component.innerHTML = result.outerHTML;
          component.classList.add('is-loaded');
          component.removeAttribute('data-jpc-loading');
          component.setAttribute('data-jpc-loaded', 'true');
          return;
        }

        var fallback = component.getAttribute('data-fallback-url');
        if (!usedFallback && fallback && fallback !== url) {
          loadRecommendationComponent(component, fallback, true);
          return;
        }

        component.removeAttribute('data-jpc-loading');
        component.setAttribute('data-jpc-loaded', 'true');
        var section = component.closest('.jpc-product-discovery__section');
        if (section) section.hidden = true;
      })
      .catch(function () {
        component.removeAttribute('data-jpc-loading');
        component.setAttribute('data-jpc-loaded', 'error');
        var section = component.closest('.jpc-product-discovery__section');
        if (section) section.hidden = true;
      });
  }

  function upgradeRecommendations(scope) {
    (scope || document).querySelectorAll('jpc-recommendations[data-url]').forEach(function (component) {
      if (component.classList.contains('is-loaded') || component.hasAttribute('data-jpc-loading') || component.hasAttribute('data-jpc-loaded')) return;
      loadRecommendationComponent(component, component.getAttribute('data-url'), false);
    });
  }

  function plainRecentMoneyFormat(format) {
    switch (format) {
      case '£{{amount}}':
      case '${{amount}}':
      case '€{{amount}}':
      case '€{{amount_with_comma_separator}}':
        return format;
      case '&pound;{{amount}}':
      case '&#163;{{amount}}':
      case '<span class=transcy-money>£{{amount}}</span>':
        return '£{{amount}}';
      case '&euro;{{amount}}':
        return '€{{amount}}';
      case '&euro;{{amount_with_comma_separator}}':
        return '€{{amount_with_comma_separator}}';
      default:
        return '£{{amount}}';
    }
  }

  function moneyFromCents(value) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format = plainRecentMoneyFormat(window.theme && window.theme.moneyFormat);
      return window.Shopify.formatMoney(value, format);
    }
    return '£' + (Number(value || 0) / 100).toFixed(2);
  }

  function createRecentlyViewedCard(product) {
    var article = document.createElement('article');
    article.className = 'jpc-discovery-card';

    var media = document.createElement('a');
    media.className = 'jpc-discovery-card__media';
    media.href = product.url || ('/products/' + product.handle);
    var image = document.createElement('img');
    image.src = product.featured_image || product.image || '';
    image.alt = product.title || '';
    image.loading = 'lazy';
    media.appendChild(image);

    var content = document.createElement('div');
    content.className = 'jpc-discovery-card__content';
    var title = document.createElement('a');
    title.className = 'jpc-discovery-card__title';
    title.href = media.href;
    title.textContent = product.title || 'View product';
    var price = document.createElement('div');
    price.className = 'jpc-discovery-card__price';
    var strong = document.createElement('strong');
    strong.textContent = moneyFromCents(product.price);
    price.appendChild(strong);
    var button = document.createElement('a');
    button.className = 'jpc-discovery-card__button';
    button.href = media.href;
    button.textContent = 'View product';
    content.appendChild(title);
    content.appendChild(price);
    content.appendChild(button);
    article.appendChild(media);
    article.appendChild(content);
    return article;
  }

  function upgradeRecentlyViewed() {
    var payload = document.querySelector('[data-jpc-current-product]');
    if (!payload) return;
    var current;
    try { current = JSON.parse(payload.textContent); } catch (error) { return; }
    if (!current || !current.handle) return;

    var storageKey = 'jpc-recently-viewed-v1';
    var previous = [];
    try { previous = JSON.parse(window.localStorage.getItem(storageKey) || '[]'); } catch (error) { previous = []; }
    if (!Array.isArray(previous)) previous = [];
    var history = previous.filter(function (item) { return item && item.handle && item.handle !== current.handle; });
    history.unshift(current);
    try { window.localStorage.setItem(storageKey, JSON.stringify(history.slice(0, 8))); } catch (error) {}

    var targets = Array.prototype.slice.call(document.querySelectorAll('[data-jpc-recently-viewed]'));
    var section = document.querySelector('[data-jpc-recently-viewed-section]');
    var products = history.slice(1, 5);
    if (!targets.length || !products.length) return;
    targets.forEach(function (target) {
      products.forEach(function (product) { target.appendChild(createRecentlyViewedCard(product)); });
    });
    if (section) section.hidden = false;
  }

  function syncShoppingBagAccessibility() {
    document.querySelectorAll('a[data-js-popup-button="cart"], a[href="/cart"][aria-label]').forEach(function (link) {
      var match = (link.textContent || '').match(/(?:bag|cart)\s*\((\d+)\)/i);
      if (!match) return;
      var count = Number(match[1]);
      link.setAttribute('aria-label', 'Open shopping bag, ' + count + ' ' + (count === 1 ? 'item' : 'items'));
    });
  }

  function upgradeStickyBrandHeader() {
    var header = document.querySelector('#header');
    if (!header) return;

    var desktopRow = header.querySelector('[data-js-desktop-sticky]');
    var mobileRow = header.querySelector('[data-js-mobile-sticky]');
    if (!desktopRow && !mobileRow) return;

    var queued = false;
    function sync() {
      queued = false;
      var desktop = window.matchMedia('(min-width: 1025px)').matches;
      var target = desktop ? desktopRow : mobileRow;
      var other = desktop ? mobileRow : desktopRow;
      var active = window.scrollY > (desktop ? 132 : 72);

      if (other) {
        other.classList.remove('header__content--sticky', 'jpc-native-scroll-sticky');
      }
      if (!target) return;

      target.classList.toggle('header__content--sticky', active);
      target.classList.toggle('jpc-native-scroll-sticky', active);
      header.classList.toggle('jpc-native-scroll-active', active);

      if (active) {
        target.querySelectorAll('img[data-srcset]').forEach(function (image) {
          if (!image.getAttribute('srcset')) image.setAttribute('srcset', image.getAttribute('data-srcset'));
        });
      }
    }

    function requestSync() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(sync);
    }

    window.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync, { passive: true });
    sync();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('#JpcCollectionFilterButton');
    if (!trigger) return;
    var source = document.querySelector('#CollectionSidebar');
    var destination = document.querySelector('#JpcCollectionFilterDialog [data-js-position-all="sidebar"]');
    if (source && destination && !destination.contains(source)) {
      source.classList.remove('js-position');
      source.removeAttribute('data-js-position-name');
      destination.appendChild(source);
    }
  }, true);

  ready(function () {
    document.documentElement.setAttribute('data-jpc-commerce-version', '26');
    upgradeCollectionPage();
    upgradeCollectionFilters();
    upgradeProductPage();
    upgradeCartPage();
    upgradeFaqPage();
    replaceLegacyTrackingLinks(document);
    upgradeRecommendations(document);
    upgradeRecentlyViewed();
    upgradeOrderedChoices(document);
    syncShoppingBagAccessibility();
    upgradeStickyBrandHeader();

    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        routeCollectionSidebar();
        upgradeOrderedChoices(document);
        replaceLegacyTrackingLinks(document);
        upgradeRecommendations(document);
        syncShoppingBagAccessibility();
        queued = false;
      });
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
